(function () {
  var sections = document.querySelectorAll('[data-ovxs-showcase]');
  if (!sections.length) return;

  function reveal(section) {
    section.classList.add('is-visible');
    var video = section.querySelector('video');
    if (video) {
      video.play().catch(function () {});
    }
  }

  if (!('IntersectionObserver' in window)) {
    sections.forEach(reveal);
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          reveal(entry.target);
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.35 }
  );

  sections.forEach(function (section) {
    observer.observe(section);
  });
})();

(function () {
  var stages = document.querySelectorAll('[data-ovxs-tilt]');
  if (!stages.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  stages.forEach(function (section) {
    var object = section.querySelector('.md-shero__object');
    if (!object) return;
    var frame = 0;
    section.addEventListener('pointermove', function (event) {
      if (frame) return;
      frame = requestAnimationFrame(function () {
        frame = 0;
        var rect = section.getBoundingClientRect();
        var x = (event.clientX - rect.left) / rect.width - 0.5;
        var y = (event.clientY - rect.top) / rect.height - 0.5;
        object.style.setProperty('--_ry', (x * 10).toFixed(2) + 'deg');
        object.style.setProperty('--_rx', (y * -8).toFixed(2) + 'deg');
      });
    });
    section.addEventListener('pointerleave', function () {
      object.style.setProperty('--_ry', '0deg');
      object.style.setProperty('--_rx', '0deg');
    });
  });
})();
